import React, { useState, useEffect } from "react";
import FilterByForDashboard from "../FilterByForDashboard";
import QuantityIndecator from "../brandScorecard/brandScorecardComponents/QuantityIndecator";
import OuncesPerUse from "./amountComponents/OuncesPerUse";
import TimeOfDay from "./amountComponents/TimeOfDay";
import DayOfWeek from "./amountComponents/DayOfWeek";
import WeekPart from "./amountComponents/WeekPart";
import { useSelector } from "react-redux";
import { useGlobalContext } from "../../../context/GlobalContext";
import {
  COMMON_PAGE_BOTTOM_TEXT,
  PROJECT_ID,
  SURVEY_BASE_SIZE_MID_VALUE,
  SURVEY_BASE_SIZE_MIN_VALUE,
} from "../../../utils/constants";
import {
  getOuncesAndGramsPerUseChartData,
  getTimeOfDayChartData,
  getDayOfWeekAndWeekPartChartData,
} from "../../../services/dashboard/amount";
import { validateCompareObjectValues } from "../../../utils/filterBy/filterBy";

const Amount = (props) => {
  const {
    productType = "",
    selectedFilters,
    setSelectedFilters,
    isFilterByApplied,
    setIsFilterByApplied,
    selectedFilterValues,
    setSelectedFilterValues,
  } = props;
  const [activeOption, setActiveOption] = useState("FILTERBY");
  const [loading, setLoading] = useState(false);
  const {
    device,
    deviceCode,
    category,
    product_id,
    showSidebar,
    project_id,
    mappedCategory,
  } = useGlobalContext();
  const [timeOfDayChartData, setTimeOfDayChartData] = useState("");
  const [dayOfWeekChartData, setDayOfWeekChartData] = useState("");
  const [weekPartChartData, setWeekPartChartData] = useState("");
  const [ounceAndGramsPerUseChartData, setOunceAndGramsPerUseChartData] =
    useState("");
  const { token, user } = useSelector((state) => state.auth);
  const { filter_week } = useSelector((state) => state.dateRange);
  const { hideFilter: isFilterHide } = useSelector((state) => state.dashboard);
  // const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [selectedHouseHoldAge, setSelectedHouseHoldAge] = useState([]);
  const [selectedHouseHoldIncome, setSelectedHouseHoldIncome] = useState([]);
  const [selectedHouseHoldSize, setSelectedHouseHoldSize] = useState([]);
  const [selectedHouseHoldChildren, setSelectedHouseHoldChildren] = useState(
    [],
  );
  const [selectedHouseHoldRaceEthnicity, setSelectedHouseHoldRaceEthnicity] =
    useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedDayPart, setSelectedDayPart] = useState([]);
  const [selectedWeekPart, setSelectedWeekPart] = useState([]);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [filterByApply, setFilterByApply] = useState(false);
  const [activeButtonDayOfWeek, setActiveButtonDayOfWeek] =
    useState("% OF TOTAL");
  const [dayOfWeekLoader, setDayOfWeekLoader] = useState(false);
  const [activeButtonWeekPart, setActiveButtonWeekPart] =
    useState("% OF TOTAL");
  const [weekPartLoader, setWeekPartLoader] = useState(false);
  // const [isFilterHide, setIsFilterHide] = useState(false);

  const getSelectedCategory = () => {
    if (selectedHouseHoldAge.length > 0) {
      return "age";
    }
    if (selectedHouseHoldIncome.length > 0) {
      return "income";
    }
    if (selectedHouseHoldSize.length > 0) {
      return "size";
    }
    if (selectedHouseHoldChildren.length > 0) {
      return "children";
    }
    if (selectedHouseHoldRaceEthnicity.length > 0) {
      return "raceEthnicity";
    }
    return "";
  };

  const getSelectedCategoriesString = () => {
    const categories = [];

    if (selectedHouseHoldAge.length > 0) {
      categories.push("age");
    }
    if (selectedHouseHoldIncome.length > 0) {
      categories.push("income");
    }
    if (selectedHouseHoldSize.length > 0) {
      categories.push("size");
    }
    if (selectedHouseHoldChildren.length > 0) {
      categories.push("children");
    }
    if (selectedHouseHoldRaceEthnicity.length > 0) {
      categories.push("raceEthnicity");
    }

    return categories.join("|");
  };

  //these are for quantity indicator
  const [activeTag, setActiveTag] = useState("OZ");

  const handleTagClick = (tag) => {
    setActiveTag(tag);
    if (tag === "OZ") {
      if (activeButtonDayOfWeek === "# OF GRAMS") {
        setActiveButtonDayOfWeek("# OF OUNCES");
      }
      if (activeButtonWeekPart === "# OF GRAMS") {
        setActiveButtonWeekPart("# OF OUNCES");
      }
    }
    if (tag === "G") {
      if (activeButtonDayOfWeek === "# OF OUNCES") {
        setActiveButtonDayOfWeek("# OF GRAMS");
      }
      if (activeButtonWeekPart === "# OF OUNCES") {
        setActiveButtonWeekPart("# OF GRAMS");
      }
    }
  };

  const fetchChartsData = () => {
    setLoading(true);
    const requestBody = {
      cat_id: parseInt(product_id),
      cat_name: category,
      chart_type: "",
      compare_with: props?.selectedComparitionBy,
      compare_by: props?.compareBy,
      project_id: parseInt(project_id),

      filter_occasion: selectedOccasions.join("|"),
      filter_household: isFilterByApplied
        ? selectedFilterValues?.houseHold
          ? Object.values(selectedFilterValues?.houseHold)
              .flat()
              .map((item) => item.uniques.trim())
              .filter((value) => value !== "All") // Remove "All" if present
              .join("|")
          : ""
        : "",
      filter_household_type: getSelectedCategoriesString(),
      filter_consumer_segment: "",
      filter_product_category: parseInt(product_id),
      filter_product_type: productType,
      filter_brand:
        props?.selectedComparitionBy !== "brand"
          ? selectedBrands.join("|")
          : "",
      filter_form:
        props?.selectedComparitionBy !== "form" ? selectedForms.join("|") : "",
      filter_day_part: selectedDayPart.join("|"),
      filter_week_part: selectedWeekPart.join("|"),
      graph_type: "",
      how_long_use_per: "",
      section_type:
        props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
          ? "compare"
          : "filter",
      how_often_use_per: "",
      weight_type: activeTag === "OZ" ? "ounce" : "gram",
      filter_week: filter_week,
      mapped_category: mappedCategory,
    };
    Promise.all([
      getOuncesAndGramsPerUseChartData({ ...requestBody }, token),
      getTimeOfDayChartData({ ...requestBody }, token),
    ])
      .then(([ouncesAndGramsPerUseResponse, timeOfDayResponse]) => {
        setOunceAndGramsPerUseChartData(
          ouncesAndGramsPerUseResponse.data.graphs,
        );
        setTimeOfDayChartData(timeOfDayResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const fetchDayOfWeekAndWeekPartData = () => {
  //   setLoading(true);
  //   const requestBody = {
  //     cat_id: parseInt(product_id),
  //     cat_name: category,
  //     chart_type: "",
  //     compare_with: props?.selectedComparitionBy,
  //     compare_by: props?.compareBy,
  //     project_id: parseInt(PROJECT_ID),

  //     filter_occasion: selectedOccasions.join("|"),
  //     filter_household: [
  //       ...selectedHouseHoldAge,
  //       ...selectedHouseHoldIncome,
  //       ...selectedHouseHoldSize,
  //       ...selectedHouseHoldChildren,
  //       ...selectedHouseHoldRaceEthnicity,
  //     ]
  //       .map((item) => item.uniques)
  //       .join("|"),
  //     filter_household_type: getSelectedCategoriesString(),
  //     filter_consumer_segment: "",
  //     filter_product_category: parseInt(product_id),
  //     filter_product_type: productType,
  //     filter_brand: selectedBrands.join("|"),
  //     filter_form: selectedForms.join("|"),
  //     graph_type: "",
  //     how_long_use_per: "",
  //     section_type:
  //       props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
  //         ? "compare"
  //         : "filter",
  //     how_often_use_per: "",
  //   };
  //   Promise.all([
  //     getDayOfWeekAndWeekPartChartData(
  //       { ...requestBody, day_type: "day", sub_graph_type:
  //         activeButtonDayOfWeek === "% OF TOTAL"
  //           ? "percentage_of_total"
  //           : "number_of_usage", },
  //       token,
  //     ),
  //     getDayOfWeekAndWeekPartChartData(
  //       { ...requestBody, day_type: "week" },
  //       token,
  //     ),
  //   ])
  //     .then(([dayOfWeekResponse, weekPartResponse]) => {
  //       setDayOfWeekChartData(dayOfWeekResponse.data.graphs);
  //       setWeekPartChartData(weekPartResponse.data.graphs);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching chart data:", error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const getRequestBody = () => ({
    cat_id: parseInt(product_id),
    cat_name: category,
    chart_type: "",
    compare_with: props?.selectedComparitionBy,
    compare_by: props?.compareBy,
    project_id: parseInt(project_id),

    filter_occasion: selectedOccasions.join("|"),
    filter_household: isFilterByApplied
      ? selectedFilterValues?.houseHold
        ? Object.values(selectedFilterValues?.houseHold)
            .flat()
            .map((item) => item.uniques.trim())
            .filter((value) => value !== "All") // Remove "All" if present
            .join("|")
        : ""
      : "",
    filter_household_type: getSelectedCategoriesString(),
    filter_consumer_segment: "",
    filter_product_category: parseInt(product_id),
    filter_product_type: productType,
    filter_brand:
      props?.selectedComparitionBy !== "brand" ? selectedBrands.join("|") : "",
    filter_form:
      props?.selectedComparitionBy !== "form" ? selectedForms.join("|") : "",
    graph_type: "",
    how_long_use_per: "",
    section_type:
      props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
        ? "compare"
        : "filter",
    how_often_use_per: "",
    weight_type: activeTag === "OZ" ? "ounce" : "gram",
    filter_week: filter_week,
    mapped_category: mappedCategory,
  });

  const fetchDayOfWeekData = () => {
    setDayOfWeekLoader(true);
    const requestBody = getRequestBody();

    getDayOfWeekAndWeekPartChartData(
      {
        ...requestBody,
        day_type: "day",
        sub_graph_type:
          activeButtonDayOfWeek === "% OF TOTAL"
            ? "percentage_of_total"
            : "number_of_usage",
      },
      token,
    )
      .then((response) => {
        setDayOfWeekChartData(response.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching Day of the Week chart data:", error);
      })
      .finally(() => {
        setDayOfWeekLoader(false);
      });
  };

  const fetchWeekPartData = () => {
    setWeekPartLoader(true);
    const requestBody = getRequestBody();

    getDayOfWeekAndWeekPartChartData(
      {
        ...requestBody,
        day_type: "week",
        sub_graph_type:
          activeButtonWeekPart === "% OF TOTAL"
            ? "percentage_of_total"
            : "number_of_usage",
      },
      token,
    )
      .then((response) => {
        setWeekPartChartData(response.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching Week Part chart data:", error);
      })
      .finally(() => {
        setWeekPartLoader(false);
      });
  };

  useEffect(() => {
    fetchChartsData();
  }, [filterByApply, props?.apply, activeTag, filter_week]);

  useEffect(() => {
    fetchDayOfWeekData();
  }, [
    filterByApply,
    props?.apply,
    activeButtonDayOfWeek,
    activeTag,
    filter_week,
  ]);

  useEffect(() => {
    fetchWeekPartData();
  }, [
    filterByApply,
    props?.apply,
    activeButtonWeekPart,
    activeTag,
    filter_week,
  ]);

  const handleReset = () => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    setSelectedHouseHoldAge([]);
    setSelectedForms([]);
    setSelectedHouseHoldIncome([]);
    setSelectedHouseHoldSize([]);
    setSelectedHouseHoldChildren([]);
    setSelectedHouseHoldRaceEthnicity([]);
    setFilterByApply(!filterByApply);
    setIsFilterByApplied(false);
    setSelectedFilterValues({});
  };

  const handleFilterApply = () => {
    setSelectedFilterValues((prevProp) => {
      return {
        ...prevProp,
        houseHold: selectedFilters,
      };
    });
  };

  return (
    <div className="row">
      {/* {user?.type === "superadmin" ? ( */}
      <FilterByForDashboard
        loading={loading}
        setLoading={setLoading}
        device={device}
        deviceCode={deviceCode}
        category={category}
        product_id={product_id}
        productType={productType}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        amount={true}
        selectedForms={selectedForms}
        setSelectedForms={setSelectedForms}
        selectedBrands={selectedBrands}
        setSelectedBrands={setSelectedBrands}
        selectedGenders={selectedGenders}
        setSelectedGenders={setSelectedGenders}
        selectedOccasions={selectedOccasions}
        setSelectedOccasions={setSelectedOccasions}
        selectedHouseHoldAge={selectedHouseHoldAge}
        setSelectedHouseHoldAge={setSelectedHouseHoldAge}
        selectedHouseHoldIncome={selectedHouseHoldIncome}
        setSelectedHouseHoldIncome={setSelectedHouseHoldIncome}
        selectedHouseHoldSize={selectedHouseHoldSize}
        setSelectedHouseHoldSize={setSelectedHouseHoldSize}
        selectedHouseHoldChildren={selectedHouseHoldChildren}
        setSelectedHouseHoldChildren={setSelectedHouseHoldChildren}
        selectedHouseHoldRaceEthnicity={selectedHouseHoldRaceEthnicity}
        setSelectedHouseHoldRaceEthnicity={setSelectedHouseHoldRaceEthnicity}
        selectedDayPart={selectedDayPart}
        setSelectedDayPart={setSelectedDayPart}
        selectedWeekPart={selectedWeekPart}
        setSelectedWeekPart={setSelectedWeekPart}
        selectedTimeOfDay={selectedTimeOfDay}
        setSelectedTimeOfDay={setSelectedTimeOfDay}
        apply={filterByApply}
        setApply={(filterByflagValue) => {
          setFilterByApply(filterByflagValue);
          setIsFilterByApplied(true);
          handleFilterApply();
        }}
        isCompareByClicked={props?.isCompareByClicked}
        setIsCompareByClicked={props?.setIsCompareByClicked}
        setSelectedFilters={setSelectedFilters}
        selectedFilters={selectedFilters}
        isDayWeekPartShow={true}
        handleReset={handleReset}
        // setIsFilterHide={(toggle) => setIsFilterHide(toggle)}
        selectedComparitionBy={props?.selectedComparitionBy}
      />
      {/* ) : (
        ""
      )} */}
      <div
        className={isFilterHide ? `col-12` : `col-9`}
        style={{ padding: "0px 3%" }}
      >
        <QuantityIndecator
          activeTag={activeTag}
          setActiveTag={setActiveTag}
          handleTagClick={handleTagClick}
        />
        <OuncesPerUse
          chartData={ounceAndGramsPerUseChartData}
          loading={loading}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
          activeTag={activeTag}
        />
        <TimeOfDay
          chartData={timeOfDayChartData}
          loading={loading}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
          activeTag={activeTag}
        />
        <DayOfWeek
          activeButtonDayOfWeek={activeButtonDayOfWeek}
          setActiveButtonDayOfWeek={setActiveButtonDayOfWeek}
          chartData={dayOfWeekChartData}
          dayOfWeekLoader={dayOfWeekLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
          activeTag={activeTag}
        />
        <WeekPart
          activeButtonWeekPart={activeButtonWeekPart}
          setActiveButtonWeekPart={setActiveButtonWeekPart}
          chartData={weekPartChartData}
          weekPartLoader={weekPartLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
          activeTag={activeTag}
        />

        <div
          className="text-light-gray text-start my-3"
          style={{
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {/* {COMMON_PAGE_BOTTOM_TEXT} */}
          <div>{`*Low sample (n<${SURVEY_BASE_SIZE_MIN_VALUE} survey responses)`}</div>
          <div>{`^Directional Use Only (n=${SURVEY_BASE_SIZE_MID_VALUE} survey responses)`}</div>
        </div>
      </div>
    </div>
  );
};

export default Amount;
